import { useState, useEffect } from 'react';
import { Download, X } from '../../icons/wp-icons';
import { getHostBranding } from '../../utils/hostBranding';

export default function InstallPrompt() {
  const hostBranding = getHostBranding();
  const [showPrompt, setShowPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    // Check if dismissed recently (within 7 days)
    const dismissedAt = localStorage.getItem('pwa-install-dismissed');
    if (dismissedAt) {
      const daysSinceDismissed = (Date.now() - parseInt(dismissedAt)) / (1000 * 60 * 60 * 24);
      if (daysSinceDismissed < 7) {
        return;
      }
    }

    // Check if install is already available
    if (window.isPWAInstallAvailable && window.isPWAInstallAvailable()) {
      setShowPrompt(true);
    }

    // Listen for install-available event
    const handleInstallAvailable = () => {
      setShowPrompt(true);
    };

    const handleInstalled = () => {
      setIsInstalled(true);
      setShowPrompt(false);
    };

    window.addEventListener('pwa-install-available', handleInstallAvailable);
    window.addEventListener('pwa-installed', handleInstalled);

    return () => {
      window.removeEventListener('pwa-install-available', handleInstallAvailable);
      window.removeEventListener('pwa-installed', handleInstalled);
    };
  }, []);

  const handleInstall = () => {
    if (window.showPWAInstallPrompt) {
      window.showPWAInstallPrompt();
      setShowPrompt(false);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-install-dismissed', Date.now().toString());
  };

  if (isInstalled || !showPrompt) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 animate-slide-up">
      <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-4">
        <div className="flex items-start gap-3">
          <img
            src={hostBranding?.logo || "/icons/icon-96x96.png"}
            alt={hostBranding?.name || "WerkPilot"}
            className="flex-shrink-0 w-12 h-12 rounded-xl"
          />

          <div className="flex-1">
            <h3 className="font-semibold text-gray-900 mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              App installieren
            </h3>
            <p className="text-sm text-gray-600 mb-3">
              Installieren Sie {hostBranding?.name || 'WerkPilot'} als App für schnelleren Zugriff und Offline-Nutzung
            </p>

            <div className="flex gap-2">
              <button
                onClick={handleInstall}
                className="flex-1 flex items-center justify-center gap-2 px-4 py-2 text-white rounded-lg transition text-sm font-medium"
                style={{ backgroundColor: hostBranding?.accent || '#378ab2' }}
              >
                <Download className="w-4 h-4" />
                Installieren
              </button>
              <button
                onClick={handleDismiss}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition text-sm"
              >
                Später
              </button>
            </div>
          </div>

          <button
            onClick={handleDismiss}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
